<template>
  <div class="edit-comment-box">
    <div class="edit-comment" @click.stop>
      <label>Wpisz tytuł komentarza</label>
      <BaseInput
        id="comment-input"
        test-id="DietDetailComments__Comment"
        class="edit-comment__input"
        :model-value="comment.title"
        maxlength="50"
        @update:model-value="emit('title', $event)"
      />
      <label>Wpisz treść komentarza</label>
      <BaseTextarea
        class="edit-comment__textarea"
        :model-value="comment.content"
        maxlength="5000"
        @update:model-value="emit('content', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseInput from '@/components/BaseInput.vue'
  import BaseTextarea from '@/components/BaseTextarea.vue'

  defineProps<{ comment: { content: string; title: string } }>()
  const emit = defineEmits<{ content: [value: string]; title: [value: string] }>()
</script>
